/**
 *  Games launcher
 */

define(function(require, exports, module) {
    'use strict';
    const _ = require('underscore');
    const core = require('core');
    const i18n = require('i18n');
    const device = require('util/device.util');
    const Launcher = require('modules/launcher/launcher');

    _.extend(Launcher, {

        /**
         * Game that launched right now
         * @param  {String} gameCode -- game code in gamesConfiguration
         * @param  {Number} mode     -- real or demo mode
         * @param  {String=} queryString -- additional URL params
         */
        _showBeforeGameLaunchPopup: function(gameCode, mode, queryString, options) {
            const game = this._getGame(gameCode);
            const buttonTitle = i18n.t('playtech.mobile.system.button.realPlay') + ' ' + game.name;
            const popupContent = i18n.t('playtech.mobile.system.games.popup-blocker-with-confirm');

            window.Playtech.API.popup.showPopup({
                content: popupContent,
                buttons: [
                    {
                        text: buttonTitle,
                        onClick: () => this.launchGame(gameCode, mode, queryString, options)
                    }
                ],
                onClose: function() {
                    core.trigger('page:refresh');
                }
            });
        },

        _handleSuccessLogin: function(gameCode, mode, queryString, options) {
            const isMobile = device.isMobilePlatform;
            const launchInThisWindow = this._isLaunchInThisWindow(gameCode);
            const launchInNewWindow = this._isLaunchInNewWindow(gameCode);

            if (isMobile && launchInThisWindow || !isMobile && launchInNewWindow) {
                this._showBeforeGameLaunchPopup(gameCode, mode, queryString, options);
            } else if (isMobile && !launchInThisWindow) {
                return this.launchGame(gameCode, mode, queryString, options);
            } else {
                this.launchGame(gameCode, mode, queryString, options);
            }
        },

        _isLaunchInThisWindow: function(gameCode) {
            const launchedMethod = this._getLaucherMethod(gameCode);

            return launchedMethod === 'iframeInThisWindow'
                || launchedMethod === 'redirectInThisWindow';

        }
    });

    module.exports = Launcher;
});
